import type { InspirationHubProps } from 'src/components/templates/InspirationHub/InspirationHub';
import type { DepartmentCardContent } from 'src/services/contentstack/fetchDepartmentCards';
import type { InspirationPostContent } from 'src/services/contentstack/fetchInspirationLibrary';
import type { InspirationTermNames } from 'src/services/contentstack/fetchInspirationTermNames';
import { INSPIRATION_CATEGORY_TAXONOMY_UID } from 'src/services/contentstack/fetchInspirationTermNames';
import { INSPIRATION_HUB_PATH } from 'src/utils/inspirationUrls';
import { ALL_POSTS_TAB_ID, buildInspirationTabs } from './buildInspirationTabs';
import { toDepartmentCardProps } from './toDepartmentCardProps';
import { toInspirationCardProps } from './toInspirationCardProps';
import { toInspirationLayoutProps } from './toInspirationLayoutProps';

/** How many of each category's latest posts the hub shows. */
export const CATEGORY_PREVIEW_SIZE = 4;

const DEPARTMENT_URLS_TO_SHOW = [
  '/department/christmas',
  '/department/gifts',
  '/department/jewellery',
  '/department/home',
  '/department/fashion',
  '/department/food-drink',
  '/department/flowers',
  '/department/games-hobbies',
  '/department/baby-child',
  '/department/weddings',
];
/** `/inspiration`: the latest posts of each category, in tab order, then every department. */
export const toInspirationHubProps = (
  library: InspirationPostContent[],
  categoryNames: InspirationTermNames,
  departments: DepartmentCardContent[],
): InspirationHubProps => {
  const tabs = buildInspirationTabs(library, INSPIRATION_CATEGORY_TAXONOMY_UID, categoryNames);
  const categoryTabs = tabs.filter(({ id }) => id !== ALL_POSTS_TAB_ID);
  const departmentsToShow = departments.filter(({ url }) => DEPARTMENT_URLS_TO_SHOW.includes(url));

  return {
    ...toInspirationLayoutProps({
      activeTabId: ALL_POSTS_TAB_ID,
      crumbs: [],
      href: INSPIRATION_HUB_PATH,
      tabs,
      titleParts: [],
    }),
    categories: categoryTabs.map(({ href, id, label, posts }, index) => ({
      heading: label,
      href,
      id,
      // Only the first card on the page can be above the fold.
      posts: toInspirationCardProps(posts.slice(0, CATEGORY_PREVIEW_SIZE), {
        eagerImageCount: index === 0 ? 1 : 0,
      }),
    })),
    departments: toDepartmentCardProps(departmentsToShow),
  };
};
